(function() {
  class $322cc90b56fb07f1$var$SiteHeader extends HTMLElement {
    constructor() {
      super();
      this.currentOpenMenu = null;
    }
    connectedCallback() {
      this.handleScrollSticky(this, "is-sticky");
      const searchEl = document.querySelector("[data-header-search-outer]");
      if (searchEl && window.scrollY > 0) searchEl.dataset.hidden = "";
      this.mobileSearchToggle = this.querySelector("[data-mobile-search-toggle]");
      this.mobileSearchInstance = this.querySelector(".header-search--mobile");
      this.mobileSearchDetails = this.mobileSearchInstance?.querySelector("[data-predictive-search-details]");
      this.removeMobileSearchHandlers = this.handleMobileSearchToggle();
      this.removeSearchScroll = this.handleScrollSearch(searchEl);
      this.removeNavListener = this.handleMobileNavEvent(searchEl);
    }
    disconnectedCallback() {
      this.removeScroll?.();
      this.removeSearchScroll?.();
      this.removeMobileSearchHandlers?.();
      this.removeNavListener?.();
    }
    handleScrollSticky(targetElement, stickyClass) {
      if (!targetElement) return;
      const onScroll = () => {
        if (window.scrollY > 0) targetElement.classList.add(stickyClass); else targetElement.classList.remove(stickyClass);
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      onScroll();
      this.removeScroll = () => window.removeEventListener("scroll", onScroll);
    }
    handleMobileNavEvent(searchEl) {
      if (!searchEl) return () => {};
      const onNavToggle = event => {
        const isNavOpen = event.detail.open;
        this.isMobileNavOpen = isNavOpen;
        if (isNavOpen) {
          if (typeof this.forceSearchState === "function") this.forceSearchState(false);
        } else if (window.scrollY === 0 && typeof this.forceSearchState === "function") this.forceSearchState(false);
      };
      window.addEventListener("mobile-nav:toggle", onNavToggle);
      return () => window.removeEventListener("mobile-nav:toggle", onNavToggle);
    }
    handleScrollSearch(searchEl) {
      if (!searchEl) return () => {};
      let lastScrollY = Math.max(0, window.scrollY);
      let pendingTimer = null;
      let committedDirection = null;
      let cooldown = false;
      this.forceSearchState = shouldHide => {
        clearTimeout(pendingTimer);
        if (shouldHide) {
          searchEl.dataset.hidden = "";
          committedDirection = "down";
        } else {
          delete searchEl.dataset.hidden;
          committedDirection = "up";
        }
        cooldown = true;
        setTimeout(() => {
          lastScrollY = Math.max(0, window.scrollY);
          committedDirection = null;
          cooldown = false;
        }, 300);
      };
      const onScroll = () => {
        if (cooldown || this.isMobileNavOpen) return;
        const currentScrollY = Math.max(0, window.scrollY);
        const direction = currentScrollY > lastScrollY ? "down" : "up";
        lastScrollY = currentScrollY;
        if (direction === committedDirection) return;
        committedDirection = direction;
        clearTimeout(pendingTimer);
        pendingTimer = setTimeout(() => {
          if (direction === "down") searchEl.dataset.hidden = ""; else delete searchEl.dataset.hidden;
          cooldown = true;
          setTimeout(() => {
            lastScrollY = Math.max(0, window.scrollY);
            committedDirection = null;
            cooldown = false;
          }, 500);
        }, 800);
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", onScroll);
        clearTimeout(pendingTimer);
        this.forceSearchState = null;
      };
    }
    handleMobileSearchToggle() {
      if (!this.mobileSearchToggle || !this.mobileSearchDetails) return () => {};
      const syncToggle = () => {
        const isOpen = Boolean(this.mobileSearchDetails?.open);
        this.mobileSearchToggle.classList.toggle("is-active", isOpen);
        this.mobileSearchToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      };
      const onToggleClick = () => {
        if (this.mobileSearchDetails.open) {
          const detailsDisclosure = this.mobileSearchDetails.closest("details-disclosure");
          if (detailsDisclosure && typeof detailsDisclosure.close === "function") detailsDisclosure.close(); else this.mobileSearchDetails.open = false;
        } else this.mobileSearchDetails.open = true;
      };
      const onSearchStateChange = event => {
        if (event.target !== this.mobileSearchInstance) return;
        syncToggle();
      };
      this.mobileSearchToggle.addEventListener("click", onToggleClick);
      this.mobileSearchInstance?.addEventListener("predictive-search:state-change", onSearchStateChange);
      syncToggle();
      return () => {
        this.mobileSearchToggle?.removeEventListener("click", onToggleClick);
        this.mobileSearchInstance?.removeEventListener("predictive-search:state-change", onSearchStateChange);
      };
    }
  }
  if (!customElements.get("site-header")) customElements.define("site-header", $322cc90b56fb07f1$var$SiteHeader);
})();